<script>
	// Stores 
	import { textSite, linkWhatsappCondominio, linkAV, linkConheca, mailProposta } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';

	let items = [
		{
			icon: 'fas fa-credit-card',
			text: '<ul><li><i class="fal fa-check"></i> Cartão de crédito do Síndico, facilitando o dia a dia, sem custo.</li></ul>'
		},
		{
			icon: 'fas fa-motorcycle',
			text: '<ul><li><i class="fal fa-check"></i> Motoboy, sem custo.</li></ul>'
		},
		{
			icon: 'fas fa-chart-line-down',
			text: '<ul><li><i class="fal fa-check"></i> Garantia de redução de aproximadamente 30% dos custos fixos.</li><li><i class="fal fa-check"></i> Negociação de contratos (gás, elevador, etc.).</li></ul>'
		},
		{
			icon: 'fas fa-users-class',
			text: '<ul><li><i class="fal fa-check"></i> Sala de reunião, sem custo.</li></ul>'
		},
		{
			icon: 'fas fa-balance-scale',
			text: '<ul><li><i class="fal fa-check"></i> Consultas e auxílio jurídico, sem custos.</li><li><i class="fal fa-check"></i> Cobrança mensal de inadimplentes.</li></ul>'
		},
		{
			icon: 'fas fa-calculator-alt',
			text: '<ul><li><i class="fal fa-check"></i> Contabilidade dos condomínios.</li><li><i class="fal fa-check"></i> Controle de retenções e recolhimento de impostos (INSS, ISSQN, IR, PIS, COFINS, CSLL).</li><li><i class="fal fa-check"></i> Obrigações acessórias (RAIS, GFIP, DIRF, DEC, ISSQN, CAGED).</li></ul>'
		},
		{
			icon: 'fas fa-file-check',
			text: '<ul><li><i class="fal fa-check"></i> Prestação de contas digital.</li><li><i class="fal fa-check"></i> Documentos digitalizados diariamente.</li></ul>'
		},
		{
			icon: 'fas fa-user-headset',
			text: '<ul><li><i class="fal fa-check"></i> Assessor fixo, sempre pronto para atendê-lo.</li><li><i class="fal fa-check"></i> Retorno no mesmo dia, por telefone, e-mail ou whatsapp.</li></ul>'
		},
		{
			icon: 'fas fa-users',
			text: '<ul><li><i class="fal fa-check"></i> Suporte nas contratações e controle de pessoal.</li><li><i class="fal fa-check"></i> Auditoria mensal de documentos nas contratações das terceirizadas.</li></ul>'
		},
		{
			icon: 'fas fa-tools',
			text: '<ul><li><i class="fal fa-check"></i> Indicação de profissionais referenciados.</li><li><i class="fal fa-check"></i> Realização de orçamentos.</li><li><i class="fal fa-check"></i> Acompanhamento até a conclusão do serviço.</li></ul>'
		},
		{
			icon: 'fas fa-badge-percent',
			text: '<ul><li><i class="fal fa-check"></i> Juros reduzidos na ocorrência de saldo negativo.</li></ul>'
		},
		{
			icon: 'fas fa-phone-laptop',
			text: '<ul><li><i class="fal fa-check"></i> Site e aplicativo.</li><li><i class="fal fa-check"></i> Extrato atualizado e 2º via de boleto.</li><li><i class="fal fa-check"></i> Atas, convenção e outros docs.</li><li><i class="fal fa-check"></i> Reserva de áreas comuns.</li><li><i class="fal fa-check"></i> Informar portaria de convidados.</li></ul>'
		}
	];

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email'
		},
		{
			title:      'Você é síndico?',
			name:       'eh-sindico',
			type:       'select',
			selectValues: [
				{
					title: 'Selecione',
					value: ''
				},
				{
					title: 'Sim',
					value: 'Sim'
				},
				{
					title: 'Não',
					value: 'Não'
				}
			]
		},
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required'
		},
		{
			title:      'Endereço *',
			name:       'condominio-endereco',
			required:   'required'
		},   
		{
			title:      'Número de unidades *',
			name:       'condominio-unidades',
			required:   'required'
		},   
		{
			title:      'Tipo de condomínio',
			name:       'tipo-condominio',
			type:       'select',
			selectValues: [
				{
					title: 'Residencial',
					value: 'Residencial'
				},
				{
					title: 'Comercial',
					value: 'Comercial'
				},
				{
					title: 'Misto',
					value: 'Misto'
				}
			]
		},    
		{
			title:      'Preferência de contato',
			name:       'preferencia-contato',
			type:       'select',
			selectValues: [
				{
					title: 'Por Whatsapp',
					value: 'Por Whatsapp'
				},
				{
					title: 'Por Email',
					value: 'Por Email'
				}
			]
		},    
		   
	];      
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é síndico?: {eh-sindico}
Nome do condomínio: {condominio-nome}
Endereço: {condominio-endereco}
Número de unidade: {condominio-unidades}
Tipo de condomínio: {tipo-condominio}
Preferência de contato: {preferencia-contato}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<div class="offset-md-3 col-md-6 pl-0 pr-0 pb-20">
		<iframe title="Vídeo institucional" style="width: 100%" height="450" src="https://www.youtube.com/embed/dsP0vI_gpEU?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	</div>		

	<div class="grid grid-size--1 grid-size-sm--1">
		<div class="grid grid-size--4 grid-size-md--2 grid-size-sm--1 gap-20 text-center">
			{#each items as item, i}
			<div class="item background-gray round-all pa-20">
				<div class="flex flex-center">
					<div class="background-accent color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<p>{@html item.text}</p>
			</div>
			{/each}
		</div>
		<div>
			<hr>
			<p class="text-center">
				Estamos prontos para assessorar sua escolha das melhores soluções para o seu condomínio. Venha conhecer nossa empresa ou solicite-nos uma proposta.
			</p>
			<div class="button text-center mt-40">
				<a href="/solicite-proposta" use:link replace title="Solicite uma proposta" class="btn btn-primary">Solicite uma proposta <i class="far fa-arrow-right"></i></a>
			</div>
		</div>
	</div>
</div>